package ui.components.molecules

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*
import ui.components.atoms.IconButton
import ui.theme.ThemeMode

@Composable
fun AppHeader(
    isAuthenticated: Boolean,
    onThemeToggle: () -> Unit,
    onSettingsClick: () -> Unit,
    onAddActionClick: () -> Unit
) {
    Header(
        attrs = {
            classes("app-header")
            style {
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceBetween)
                alignItems(AlignItems.Center)
                padding(16.px)
                backgroundColor(Color("var(--bg-secondary)"))
                property("border-bottom", "1px solid #e5e7eb")
            }
        }
    ) {
        // Logo/Title
        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(12.px)
                }
            }
        ) {
            Span(
                attrs = {
                    style {
                        fontSize(24.px)
                    }
                }
            ) {
                Text("📊")
            }
            
            H1(
                attrs = {
                    style {
                        margin(0.px)
                        fontSize(20.px)
                        fontWeight("600")
                        color(Color("var(--text-primary)"))
                    }
                }
            ) {
                Text("PR Dashboard")
            }
        }
        
        // Header actions
        if (isAuthenticated) {
            Div(
                attrs = {
                    style {
                        display(DisplayStyle.Flex)
                        alignItems(AlignItems.Center)
                        gap(8.px)
                    }
                }
            ) {
                IconButton(
                    icon = "🌙",
                    onClick = onThemeToggle,
                    title = "Toggle theme"
                )
                
                IconButton(
                    icon = "+",
                    onClick = onAddActionClick,
                    title = "Add custom action"
                )
                
                IconButton(
                    icon = "⚙️",
                    onClick = onSettingsClick,
                    title = "Settings"
                )
            }
        }
    }
}